/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded Expand More on a `dxp-accent` 0.16 opacity background.
 * @export
 */
export const CUSTOM_ICON_EXPAND_MORE = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#1D9BE2" fillOpacity="0.16" height="20" rx="10" width="20" x="2" y="2" />
    <path
      d="M8.0035 10.2925L11.8835 14.1725L15.7635 10.2925C16.1535 9.9025 16.7835 9.9025 17.1735 10.2925C17.5635 10.6825 17.5635 11.3125 17.1735 11.7025L12.5835 16.2925C12.1935 16.6825 11.5635 16.6825 11.1735 16.2925L6.5835 11.7025C6.39625 11.5157 6.29102 11.262 6.29102 10.9975C6.29102 10.733 6.39625 10.4793 6.5835 10.2925C6.9735 9.9125 7.6135 9.9025 8.0035 10.2925Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
);
